module.exports = __webpack_public_path__ + "static/1210530744.9a4036f7.jpg";